export const LANGUAGES_CONSTS = {
    GET_LANGUAGES: "GET_LANGUAGES",
    CREATE_LANGUAGES: 'CREATE_LANGUAGES',
    DELETE_LANGUAGE: 'DELETE_LANGUAGE',
    UPDATE_LANGUAGE: 'UPDATE_LANGUAGE',
};

export const LIMIT_GET_LANGUAGES = 10;